export default {
  page: {
    greeting: 'Hi {{name}}, welcome to the Partner Portal',
    greetingFallbackName: 'there',
    subtitle: 'Track your referrals, monthly earnings, and commissioned contests.',
    disclaimer:
      'This program and partner portal are subject to the <termsLink>Commissioner Rewards Program Terms and Conditions</termsLink> and may be modified or discontinued at our sole discretion.',
    summaryCards: {
      totalSignups: 'New Signups',
      paidUsers: 'New Paying Users',
      qpUsers: 'New QuickPicks Users',
      totalQpFees: 'QuickPicks Real Money Handle',
      predictUsers: 'New Predict Users',
    },
  },
  aboutColumns: {
    title: 'About these columns',
    items: {
      newSignups: {
        term: 'Signups',
        description:
          'new users attributed to you who signed up that month (includes free/voucher participation seats).',
      },
      attribution: {
        term: 'via Code / via Contest',
        description:
          'of those signups, how they were attributed to you (referral code vs commissioned contest).',
      },
      survivor: {
        term: '$21M NFL Users / $21M NFL Entries',
        description:
          'users whose first entry into The Survivor World Championship ($21M NFL) was that month, and total entries by your users.',
      },
      newPayingUsers: {
        term: 'New Paid Users',
        description:
          'first real-money activity that month, across contests, QuickPicks, or Predict.',
      },
      newQuickPicksUsers: {
        term: 'New QuickPicks Users',
        description: 'first real-money QuickPicks entry that month.',
      },
      qpHandle: {
        term: 'QuickPicks Real Money Handle',
        description: 'total real-money QuickPicks entry fees from your users that month.',
      },
      newPredictUsers: {
        term: 'New Predict Users',
        description: 'users whose first real-money (at least $1) Predict trade was that month.',
      },
      playedAll3: {
        term: 'Played All 3',
        description:
          'users who went real-money in all three products (Contests, QuickPicks, Predict), counted in the month they complete all three.',
      },
      byCode: {
        term: 'By Code, Code / Code Type',
        description:
          'which of your codes the user was attributed through: a referral or promo code, or "First Contest" for commissioned-contest signups that carry no code.',
      },
    },
  },
  section: {
    errorTitle: "Couldn't load this report",
    errorBody:
      'Something went wrong fetching the data. Try a different period or refresh the page.',
    emptyTitle: 'No data for this period',
    dataAsOf: 'Data as of {{date}}',
  },
  referralTracking: {
    title: 'Referral Tracking',
    ariaLabel: 'Referral tracking by month',
    itemName: 'months',
    emptyMessage: 'No signups or referral activity for the selected year.',
    periodLabel: 'Year',
    columns: {
      month: 'Month',
      signups: 'Signups',
      viaCode: 'via Code',
      viaContest: 'via Contest',
      contest21mUsers: '$21M NFL Users',
      contest21mEntries: '$21M NFL Entries',
      paidUsers: 'New Paid Users',
      qpUsers: 'New QP Users',
      newPredictUsers: 'New Predict Users',
      playedAll3: 'Played All 3',
      qpFiatFees: 'QP Handle',
    },
  },
  codePerformance: {
    title: 'By Code',
    ariaLabel: 'Referral activity by code and month',
    itemName: 'rows',
    emptyMessage: 'No code activity for the selected month.',
    monthLabel: 'Month',
    periodLabel: 'Year',
    columns: {
      code: 'Code',
      codeType: 'Code Type',
      signups: 'Signups',
      viaCode: 'via Code',
      viaContest: 'via Contest',
      contestUsers: 'New Contest Users',
      paidUsers: 'New Paid Users',
      qpUsers: 'New QP Users',
      newPredictUsers: 'New Predict Users',
      playedAll3: 'Played All 3',
      qpFiatFees: 'QP Handle',
    },
    codeTypes: {
      referralCode: 'Referral Code',
      promoCode: 'Promo Code',
      firstContest: 'First Contest',
    },
  },
  monthlyEarnings: {
    title: 'Monthly Earnings',
    ariaLabel: 'Monthly earnings by month',
    itemName: 'months',
    emptyMessage: 'No earnings recorded for the selected year.',
    periodLabel: 'Year',
    columns: {
      month: 'Month',
      cpaEarnings: 'CPA Earnings',
      upgradedUsersCpa: 'Upgraded Users CPA',
      qpCpa: 'QP CPA',
      contestCpa: 'Contest CPA',
      contestCommission: 'Contest Commission',
      qpRevShare: 'QP Rev Share',
      flatRate: 'Flat Rate',
      minGuarantee: 'Min Guarantee',
      guaranteeApplied: 'Guarantee Applied',
      totalEarnings: 'Total Earnings',
      amountToPay: 'Amount to Pay',
    },
  },
  commissionedContests: {
    title: 'Commissioned Contests',
    ariaLabel: 'Commissioned contests',
    itemName: 'contests',
    emptyMessage: 'No commissioned contests for the selected year.',
    periodLabel: 'Year',
    columns: {
      contestName: 'Contest Name',
      sport: 'Sport',
      status: 'Status',
      startDate: 'Start Date',
      endDate: 'End Date',
      entryFee: 'Entry Fee',
      resizingMode: 'Resizing Mode',
      inContractWindow: 'In Contract Window',
      totalEntries: 'Total Entries',
      totalHandle: 'Total Handle',
      commission: 'Commission',
    },
  },
  table: {
    defaultAriaLabel: 'Data table',
    defaultItemName: 'entries',
    results: '{{start}}-{{end}} of {{total}} {{itemName}}',
    resultsNoItem: '{{start}}-{{end}} of {{total}}',
    perPage: '{{unit}} per page',
  },
  boolean: {
    yes: 'Yes',
    no: 'No',
  },
  csv: {
    downloadError: 'Could not download the CSV. Please try again.',
  },
};
